import React from "react";
import "./Footer.scss";
import '@fortawesome/fontawesome-free/css/all.min.css';

const MAP_URL =
  'https://maps.google.com/?q=XGM3%2B67W+Sarkhej+Ahmedabad+Gujarat+382210+India';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-deco" aria-hidden="true">
        <span className="footer-om">ॐ</span>
      </div>
      <div className="footer-content">
        <div className="footer-left">
          <div className="footer-brand">
            <img
              src={require("../assets/slider-img/logo3.webp")}
              alt="Avdhoot Vishram"
              className="footer-logo"
              loading="lazy"
              decoding="async"
            />
            <div className="footer-brand-text">
              <h3>Avdhoot Vishram</h3>
              <p className="footer-tagline">A spiritual abode in the Datt Parampara</p>
            </div>
          </div>
          <p className="footer-copy">
            &copy; {new Date().getFullYear()} Avdhoot Vishram. All rights reserved.
          </p>
          <p className="footer-creator">
            Website designed &amp; developed by{' '}
            <a href="tel:+917990895673">
              <strong>Parth Trivedi</strong> &middot; +91 7990895673
            </a>
          </p>
        </div>

        <div className="footer-address">
          <h4 className="footer-address-title">
            <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
            Sarkhej Datt Mandir
          </h4>
          <a
            className="footer-address-link"
            href={MAP_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open Sarkhej Datt Mandir location on Google Maps"
          >
            <span className="footer-address-line">
              XGM3+67W, Sarkhej, Sarkhej-Okaf,
            </span>
            <span className="footer-address-line">Ahmedabad, Gujarat 382210, India</span>
            <span className="footer-address-action">
              <i className="fas fa-directions" aria-hidden="true"></i> Open in Maps
            </span>
          </a>
        </div>

        <div className="footer-right">
          <div className="footer-social-icons">
            <a
              href="https://www.facebook.com/AvdhootVishramSarkhej/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="footer-icon"
            >
              <svg viewBox="0 0 320 512" width="16" height="16" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"/>
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@AvdhootVishramSarkhej"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className="footer-icon"
            >
              <svg viewBox="0 0 576 512" width="16" height="16" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"/>
              </svg>
            </a>
          </div>
          <p className="footer-contact">
            <a href="tel:+917990895673">+91 7990895673</a>
          </p>
          <p className="footer-contact">
            <a href="mailto:info.avdhootvishram@gmail.com">info.avdhootvishram@gmail.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
